module.exports = __webpack_public_path__ + "static/img/s51.369afbf9.png";